export const LOTTIE_PLAYER_VERSION = "1.7.0"; 
export const LOTTIE_WEB_VERSION = "^5.10.0";
